export default __webpack_public_path__ + "96101d2d64aecf8409bf1147ee8af618.jpeg";